export default "__VITE_PUBLIC_ASSET__83d2c530__"